var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaution(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.72183 0.500004L17.6602 14.25C17.7333 14.3767 17.7718 14.5204 17.7718 14.6667C17.7718 14.8129 17.7333 14.9566 17.6602 15.0833C17.587 15.21 17.4818 15.3152 17.3552 15.3884C17.2285 15.4615 17.0848 15.5 16.9385 15.5H1.06183C0.915549 15.5 0.771848 15.4615 0.645169 15.3884C0.518489 15.3152 0.413294 15.21 0.340156 15.0833C0.267018 14.9566 0.228515 14.8129 0.228516 14.6667C0.228517 14.5204 0.267022 14.3767 0.340161 14.25L8.27849 0.500004C8.35164 0.373331 8.45683 0.268142 8.58351 0.195009C8.71019 0.121875 8.85389 0.083374 9.00016 0.083374C9.14643 0.083374 9.29013 0.121875 9.41681 0.195009C9.54349 0.268142 9.64869 0.373331 9.72183 0.500004ZM8.16683 11.3333V13H9.83349V11.3333H8.16683ZM8.16683 5.5V9.66667H9.83349V5.5H8.16683Z",
    fill: "#F5C02D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaution);
export default __webpack_public_path__ + "static/media/caution.a37e61f6bcb6dc6fd4147512c7e21c2b.svg";
export { ForwardRef as ReactComponent };